import { SidenavItemInterface } from 'src/app/layout/side-nav/interfaces/side-nav-items.interface';

export const subscriptionSidenavConfig: SidenavItemInterface[] = [
  {
    id: 'subscriptions',
    label: 'subscriptions',
    routerLink: '/subscriptions',
    permissions: ['VIEW_SUBSCRIPTION'],
  },
  {
    id: 'transactions',
    label: 'transactions',
    routerLink: '/transactions',
    permissions: ['VIEW_BILLING_TRANSACTION'],
  },
  {
    id: 'plan',
    label: 'plan',
    routerLink: '/plan',
    permissions: ['VIEW_PLAN'],
  },
  {
    id: 'voucher',
    label: 'voucher',
    routerLink: '/voucher',
    permissions: ['VIEW_VOUCHER'],
  },
  {
    id: 'expense',
    label: 'expense',
    routerLink: '/expense',
    permissions: ['VIEW_EXPENSE'],
  },
  {
    id: 'working-records',
    label: 'workingRecords',
    routerLink: '/working-records',
    permissions: ['VIEW_WORK_RECORD'],
  },
  {
    id: 'salary-records',
    label: 'salaryRecords',
    routerLink: '/salary-records',
    permissions: ['VIEW_SALARY_RECORD'],
  },
];
